/* Sticky navigation for pages with child navigation */
$(document).ready(function () {
    if ($('.page-navigation').length) {
        var pageNavigation = $(".page-navigation");
        var scrollToTrigger = $(".scrollTo");
        var originalOffsetTop = pageNavigation.offset().top;

        $(window).on("scroll", function () {
            var currentScrollTop = $(this).scrollTop();

            if (currentScrollTop >= originalOffsetTop) {
                pageNavigation.addClass("__sticky");
                scrollToTrigger.addClass("__active");
            } else {
                pageNavigation.removeClass("__sticky");
                scrollToTrigger.removeClass("__active");
            }
        });
    }
});

/* ScrollTo */
(function () {
    $.fn.scrollto = function (options) {
        var settings = $.extend(
            {
                trigger: '#ScrollTo',
                scroll_to: '.wrapper',
                speed: 1000,
                offset: 0
            },
            options
        );
        $(settings.trigger).click(function (event) {
            event.preventDefault();
            $('html, body').animate(
                {
                    scrollTop:
                        $(settings.scroll_to).offset().top + settings.offset
                },
                settings.speed
            );
        });
    };
})();

$('#ScrollTo').scrollto({
    trigger: '#ScrollTo',
    scroll_to: '.wrapper',
    speed: 1000
});
